import getComposeViewState from './getComposeViewState';
import getFullComposeViewState from './getFullComposeViewState';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import isQuickComposeOpen from './isQuickComposeOpen';
import { isFTDFSeriesMaster, isEventAMeeting } from 'owa-calendar-event-capabilities';

export function shouldShowOptionalAttendeeRow() {
    const { isOptionalAttendeeWellEnabled } = getComposeViewState();

    return isOptionalAttendeeWellEnabled;
}

export function shouldFocusOptionalAttendeeWellOnMount() {
    const { shouldFocusOptionalAttendeeWellOnMount } = getComposeViewState();

    return shouldFocusOptionalAttendeeWellOnMount;
}

export function shouldShowOptionalAttendeeButton() {
    return !shouldShowOptionalAttendeeRow() && !isQuickComposeOpen();
}

export function shouldShowCompactWell() {
    const { showCompactRecipientWell } = getComposeViewState();

    return !shouldShowCompactReadOnlyWell() && showCompactRecipientWell;
}

export function shouldShowCompactReadOnlyWell() {
    const { event, originalEvent } = getComposeStore();
    const fullComposeViewState = getFullComposeViewState();
    const disableRecipientRowForOnSend = fullComposeViewState
        ? !fullComposeViewState.uiEnabled
        : false;

    return (
        (isFTDFSeriesMaster(event) && isEventAMeeting(originalEvent)) ||
        disableRecipientRowForOnSend
    );
}
